(function () {
  'use strict';
  if (window.__wissensfragen) return;
  window.__wissensfragen = true;

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('.wfk__auf');
    if (!knopf) return;

    var feld = document.getElementById(knopf.getAttribute('aria-controls'));
    if (!feld) return;

    var reihe = knopf.closest('.wfr');
    var offen = knopf.getAttribute('aria-expanded') === 'true';

    if (reihe) {
      reihe.querySelectorAll('.wfk__auf[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.closest('.wfk').classList.remove('is-offen');
      });
      reihe.querySelectorAll('.wfp').forEach(function (f) { f.hidden = true; });
    }

    if (offen) return;

    knopf.setAttribute('aria-expanded', 'true');
    knopf.closest('.wfk').classList.add('is-offen');
    feld.hidden = false;
  });
})();
